import React, { Fragment } from 'react'
import iOSLandscapeFullscreen from './LandscapeFullScreen/iOSLandscapeFullscreen'
import ChromeLandscape from './LandscapeFullScreen/ChromeLandscape'
import AndroidLandscapeFullscreen from '../containers/LandscapeFullscreen/AndroidLandscapeFullscreen'
import platform from 'platform'

export const DeviceType = {
    IOS: 'iOS',
    ANDROID: 'Android',
}

export const Platform = {
    CHROME_MOBILE: 'Chrome Mobile',
}

const getLandscapeFullscreen = ({ isMobileLandscapeModeEnabled, isDesktopPlatform, isInIframe }) => {
    let LandscapeFullscreen = Fragment

    // Handle for emulated browser devices and in iFrame
    if (isDesktopPlatform || isInIframe) return LandscapeFullscreen
    else if (!isMobileLandscapeModeEnabled)
        return platform.name == Platform.CHROME_MOBILE ? ChromeLandscape : LandscapeFullscreen
    // else if (platform.os.family == DeviceType.IOS) LandscapeFullscreen = iOSLandscapeFullscreen
    else if (platform.os.family == DeviceType.ANDROID) LandscapeFullscreen = AndroidLandscapeFullscreen

    return LandscapeFullscreen
}

const withPropsCB = (cb, props) => (typeof cb == 'function' ? cb(props) : cb)

const WithLandscapeFullscreen = ({ onOrientationChangeEnd, onViewChange }) => WrappedComponent => props => {
    const LandscapeFullscreen = getLandscapeFullscreen(props)

    return (
        <LandscapeFullscreen
            onOrientationChangeEnd={withPropsCB(onOrientationChangeEnd, props)}
            onViewChange={withPropsCB(onViewChange, props)}
        >
            <WrappedComponent {...props} />
        </LandscapeFullscreen>
    )
}

export default WithLandscapeFullscreen
